var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.46 0.5H15.5157V5.90436H20.5278V0.5H25.5835V5.90436H30.5956V10.96H36V16.0157H30.5956V21.0278H36V26.0835H30.5956V31.0956H25.5835V36.5H20.5278V31.0956H15.5157V36.5H10.46V31.0956H5.40436V26.0835H0V21.0278H5.40436V16.0157H0V10.96H5.40436V5.90436H10.46V0.5ZM20.5278 10.96H15.5157V16.0157H10.46V21.0278H15.5157V26.0835H20.5278V21.0278H25.5835V16.0157H20.5278V10.96Z",
    fill: "#E74E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16624b3313cfccd353659e9612425ebd.svg";
export { ForwardRef as ReactComponent };